import axios from "axios";
import { baseUrl } from "../Common/Constants";
import httpClient from "../Core/http";

class Api {
    fetchMachineTimes(params:any){
        let url =  "machinestate/machineTimes";
        const termsobj = {
            country: params.country,
            customerID: params.customerID,
            deviceTypes: params.deviceTypes,
            devicesWithSerial: params.devicesWithSerial
          }
    
          if (params.devicesWithSerial == null){
            termsobj.devicesWithSerial = []
          }
          if (params.deviceTypes == null){
            termsobj.deviceTypes = []
          }
    
          const terms = JSON.stringify(termsobj) 
    
          const queryObject = {
                bucketSize: params.bucketSize,
                start: params.start,
                end: params.end,
                terms: terms,
                scope:params.scope
          }
          
            return  httpClient.get(url, { params: queryObject }).then((response) => {
              return response.data;
            })
                      .catch((error) => {
                          console.log(error);
                          throw error;
                      });
             
          
    }
}


export const machineStateApi = new Api();